import { render } from "./SuppliersStage.vue?vue&type=template&id=c8e00330&scoped=true"
import script from "./SuppliersStage.vue?vue&type=script&lang=js"
export * from "./SuppliersStage.vue?vue&type=script&lang=js"

import "./SuppliersStage.vue?vue&type=style&index=0&id=c8e00330&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8e00330"]])

export default __exports__